export default __webpack_public_path__ + "static/media/reebok_stimuli_fr.4d1c35cd.mp4";